import React, { useState, useCallback } from 'react';
import ComingSoon from './Components/recovery/ComingSoon';
import RecoveryNav from './Components/recovery/RecoveryNav';
import Footer1 from './Components/recovery/Footer';

const App = () => {
  return (
    <>
    {/*  <RecoveryNav /> */}
      <ComingSoon />
    {/*  <Footer1 /> */}
    </>
  );
};

export default App;
